const ENV_SAFE_ORDER = ['dev', 'test', 'uat', 'stage', 'staging'];

// Matches as a whole token (split on any non-letter run) so e.g. "nonprod"/
// "preprod" don't glue onto a "prod" match, and "devops" doesn't glue onto a
// "dev" match - plain includes() would tie those with the real environment
// and, since sort is stable, not guarantee the intended rank.
function matchesToken(key: string, target: string): boolean {
  return key.toLowerCase().split(/[^a-z]+/).includes(target);
}

function envRank(key: string): number {
  if (matchesToken(key, 'prod') || matchesToken(key, 'production')) return ENV_SAFE_ORDER.length + 1;
  const idx = ENV_SAFE_ORDER.findIndex((env) => matchesToken(key, env));
  return idx === -1 ? ENV_SAFE_ORDER.length : idx;
}

// Sorts environment keys so prod-like environments always sort last, keeping
// dev/test/uat/stage first. Shared between the flag table (columns) and the
// flag detail view (tabs) so both surfaces protect prod the same way.
export function sortEnvironmentsSafely(keys: string[]): string[] {
  return [...keys].sort((a, b) => envRank(a) - envRank(b));
}
